<div
  class="procedure-content-list object-procedure-content-list"
  [ngClass]="{'smallScreen': smallScreen}"
>
  <div class="procedure-content-list__headline">
    <div class="procedure-content-list__title">
      @if (smallScreen) {
        <a
          (click)="onToggleMenu()"
          class="procedure-content-list__toggle-button"
        >
          <mat-icon>
            {{openMenu ? 'menu_open' : 'menu'}}
          </mat-icon>
        </a>
      }

      @if (operationContainer.contentInfo.selectedMainMenu) {
        <h3 class="bold">
          <span>
            {{operationContainer.contentInfo.selectedMainMenu.count}} &nbsp;
          </span>

          <span>
            {{caption}}
          </span>
        </h3>
      }
    </div>

    <div>
      @if (!operationContainer.currentOperation?.sub_operations) {
        <button
          mat-flat-button
          type="button"
          class="add-button"
          color="primary"
          (click)="openModal()"
          [disabled]="isEditing || operationContainer.rootSectionsContainer.rootObject.read_only"
        >
          <mat-icon>
            add
          </mat-icon>

          <span  class="bold uppercase">
            {{ 'TRANS__HEADER__OBJECT_MENU__ADD' | translate }}
          </span>
        </button>
      }
    </div>
</div>

  <div class="procedure-content-list__content-list">
    @if (operationContainer.contentInfo.curListContainer) {
      <app-object-content-list-regular
        [contentListContainer]="operationContainer.contentInfo.curListContainer"
        (objectRefresh)="loadProcedure()"
      ></app-object-content-list-regular>
    }
  </div>
</div>

